(function () {
    document.addEventListener('DOMContentLoaded', function () {

        const contentLocale = document.getElementById('country_code')?.value.trim();

        if (!contentLocale) {
            return; // no locale set so halt here as we don't know which market to use
        }

        const submissionErrors = document.getElementById('form-submissionErrors');

        let ballotForm = document.querySelector('.neon-ballot-no-payment').closest('form');


        //let ballotForm = document.getElementById(`${ballotFormId}`);

        const dobDay = ballotForm.querySelector('.field--day-text');
        const dobMonth = ballotForm.querySelector('.field--month-text');
        const dobYear = ballotForm.querySelector('.field--year-text');

        const customerEmail = ballotForm.querySelector('#email-form_submit_register_interest-field');
        customerEmail.setAttribute('tabindex', '8');

        dobDay.addEventListener("keyup", function () {
            if (dobDay.value.length == 2) {
                dobMonth.focus();
            }
        });

        dobMonth.addEventListener("keyup", function () {
            if (dobMonth.value.length == 2) {
                dobYear.focus();
            }
        });

        dobYear.addEventListener("keyup", function () {
            if (dobYear.value.length == 4) {
                customerEmail.focus();
            }
        });


        ballotForm.addEventListener('submit', async function (event) {
            event.preventDefault();
            submissionErrors.textContent = '';
            console.log('submitted ballot');
            let submitBtn = document.querySelector('.field--submit button');
            submitBtn.disabled = true;
            submitBtn.style.cursor = 'wait';
            document.body.style.cursor = 'wait';;

            let fName = ballotForm.querySelector('#first-name-form_submit_register_interest-field').value.trim();
            let lName = ballotForm.querySelector('#last-name-form_submit_register_interest-field').value.trim();
            let email = ballotForm.querySelector('#email-form_submit_register_interest-field').value.trim();
            let ballotAgreement = true; // init vars,  validation of required checkboxes is handled below
            let phoneNumber = ballotForm.querySelector('#phone-form_submit_register_interest-field').value.trim();

            let dobSql = getDobFormatted('ISO_8601');
            const validationResult = validateRequiredFields(ballotForm);
            if (validationResult == false) {
                submitBtn.disabled = false;
                submitBtn.style.cursor = 'pointer';
                document.body.style.cursor = 'unset';
                return false;
            }

            const validateDobResult = validateDobField();
            if (validateDobResult === false) {
                submitBtn.disabled = false;
                submitBtn.style.cursor = 'pointer';
                document.body.style.cursor = 'unset';
                return false;
            }
            let fullName = fName + ' ' + lName;
            // important note, check these ID's match the checkboxes on the form
            let brandOptin = ballotForm.querySelector('#optin-second-form_submit_register_interest-field').checked ? true : false;
            let groupOptin = ballotForm.querySelector('#agree-form_submit_register_interest-field').checked ? true : false;

            if (!validateFullName(fullName)) {
                submissionErrors.textContent = 'Invalid characters in name fields'
                submitBtn.disabled = false;
                submitBtn.style.cursor = 'pointer';
                document.body.style.cursor = 'unset';
                return false;
            }

            try {
                const neonToken = await grecaptcha.execute('6Lfpx6whAAAAAJvpYIe2X4twQ6zHhfF_ZPxprfQr', { action: 'create_neon_record' });

                let entryData = {
                    'firstName': fName,
                    'lastName': lName,
                    'fullName': fullName,
                    'email': email,
                    'dateOfBirth': dobSql,
                    'phoneNumber': phoneNumber,
                    'ballotAgreement': ballotAgreement,
                    'brandOptin': brandOptin,
                    'groupOptin': groupOptin
                };

                let neonResult = await sendDataToNeon(entryData, neonToken, contentLocale);

                if (neonResult.success === false) {
                    submissionErrors.textContent = neonResult.message;
                    submitBtn.disabled = false;
                    submitBtn.style.cursor = 'pointer';
                    document.body.style.cursor = 'unset';
                    return false;
                }


                submitBtn.disabled = false;
                submitBtn.style.cursor = 'pointer';
                document.body.style.cursor = 'unset';
                // const contactResult = await sendContactToDogDigital(formData);
                clearBallotForm();
                showSuccessMessage(ballotForm);
                dataLayerCTA('Enter Ballot', 'Enter ballot - Pay');

            } catch (error) {
                submitBtn.disabled = false;
                submissionErrors.textContent = error;
                return false;
            }
        });

        function validateFullName(fullName) {
            // This regular expression allows Unicode letters from all scripts, spaces, hyphens, and apostrophes
            const regex = /^[\p{L}\p{M}\s'-]+$/u;
            return regex.test(fullName);
        }

        function validateRequiredFields(form) {
            // Get all inputs with required class
            // temp getting all inputs as all are required
            // we need the ability to set a required input in the cms as with the checkboxes
            const formInputs = form.querySelectorAll('input');

            let errors = false;

            // Loop through the required elements
            for (const input of formInputs) {
                const inputType = input.type;

                switch (inputType) {
                    case 'text':
                        if (input.value.trim() === '') {
                            errors = true;
                            input.classList.add('error');
                        } else {
                            input.classList.remove('error');
                        }
                        break;
                    case 'checkbox':
                        if (!input.checked && input.classList.contains('required')) {
                            errors = true;
                            input.classList.add('error');
                        } else {
                            input.classList.remove('error');
                        }
                        break;
                }
            }

            if (errors) {
                return false;
            } else {
                return true;
            }
        }

        function validateDobField() {
            let day = dobDay.value;
            let month = dobMonth.value;
            let year = dobYear.value;

            month = Number(month) - 1; // 0-indexed month
            var d = new Date(year, month, day);
            if (d.getFullYear() == year && d.getMonth() == month && d.getDate() == day) {
                dobDay.classList.remove('error');
                dobMonth.classList.remove('error');
                dobYear.classList.remove('error');
                return true;
            }

            dobDay.classList.add('error');
            dobMonth.classList.add('error');
            dobYear.classList.add('error');
            return false;
        }

        function showSuccessMessage(form) {
            // Get the parent with class '.form--submit' and retrieve its ID
            let containerElement = form.closest(".form--submit");
            let containerId = containerElement ? containerElement.id : null;
            if (containerId) {
                // Get the success message element
                const successDiv = document.querySelector('.success_message');
                // Remove all elements with class '.form--field' inside the container
                const formFields = document.querySelectorAll("#" + containerId + " .form--field");
                formFields.forEach(field => field.remove());
                // Add 'hidden' class to elements with class '.content' inside the container
                const contentElements = document.querySelectorAll("#" + containerId + " .content");
                contentElements.forEach(content => content.classList.add("hidden"));

                // Add 'hidden' class to the specific content field with ID pattern
                const specificContentField = document.getElementById("content-" + containerId + "-field");
                if (specificContentField) {
                    specificContentField.classList.add("hidden");
                }

                // Remove 'hidden' class from the success message inside the container
                const successMessage = document.querySelector("#" + containerId + " .success_message");
                if (successMessage) {
                    successMessage.classList.remove("hidden");

                    successDiv.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                }
            }
        }

        function getDobFormatted(format = false) {

            let day = dobDay.value.trim();
            let month = dobMonth.value.trim();
            let year = dobYear.value.trim();

            let dob;
            if (format === "ISO_8601") {
                dob = year + '-' + month + '-' + day;
            } else {
                dob = day + '/' + month + '/' + year;
            }

            return dob;
        }

        async function sendDataToNeon(entryData, recaptchaToken, contentLocale) {
            console.log('sending to enon');
            const response = await fetch('/webhooks/data/neon-no-payment.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "entryData": entryData,
                    "recaptchaToken": recaptchaToken,
                    "contentLocale": contentLocale
                }),
            });
            if (!response.ok) {
                console.error('Error with Neon request:', response.statusText);
            }

            const data = await response.json();
            return data;
        }

        /* Clear the elements and the form fields */
        function clearBallotForm() {
            ballotForm.reset();
        }

        function dataLayerCTA(action, label) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'ctaClicks',
                'ga_event': {
                    'category': 'Internal CTA Clicks',
                    'action': action,
                    'label': label,
                    'value': 0,
                    'nonInteraction': 0
                }
            });
        }
    });
})();